// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageNotificationsForm-manageNotificationsFormWrapper-Ze5Vq {
    padding: 24px;
    border: 1px solid var(--primary-border);
    border-radius: 4px;
    max-width: 800px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/ManageNotificationsForm/ManageNotificationsForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".manageNotificationsFormWrapper {\n    padding: 24px;\n    border: 1px solid var(--primary-border);\n    border-radius: 4px;\n    max-width: 800px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageNotificationsFormWrapper": `ManageNotificationsForm-manageNotificationsFormWrapper-Ze5Vq`
};
module.exports = ___CSS_LOADER_EXPORT___;
